import React from 'react';
import { Routes, Route } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { EmptyState } from '../../../../components/EmptyState';
import { CreateJobPageRoutes } from '../CreateJobPageRoutes';
import { SetupJobPageRoutes } from '../SetupJobPageRoutes';
import { JobPage } from '../../../JobPage';
import { EditJobPage } from '../EditJobPage';
import { HrisProvider } from '../../../../enums/IntegrationProvider/HrisProvider';
import { JobPageTab } from '../../../JobPage/JobPageTab';
import { AccountIntegration } from '../../../../entities/AccountIntegration';
import { FeatureFlagContext } from '../../../../contexts/FeatureFlagContext';

interface PropTypes {
  atsSignableOfferEnabled: boolean;
  atsHrisExportV2Enabled: boolean;
  atsUpdateSchedulingUserIntegrationUserInfoEnabled: boolean;
  emailAccountIntegration: AccountIntegration;
  jobBoardEnabled: boolean;
  duplicateJobEnabled: boolean;
  standardNpsCalculation: boolean;
  hrisProvider?: HrisProvider;
  jobRequisitionEnabled: boolean;
  jobRequisitionMandatory: boolean;
  organicPostSkillsEnabled: boolean;
  selfSchedulingLinkOptionsEnabled: boolean;
  atsIndeedIntegrationEnabled: boolean;
  offerRequisitionFlowEnabled: boolean;
}

function JobPageRouteTab(props: PropTypes & { activeTab: JobPageTab }) {
  return (
    <FeatureFlagContext.Provider
      value={{
        atsHrisExportV2Enabled: props.atsHrisExportV2Enabled,
        atsUpdateSchedulingUserIntegrationUserInfoEnabled:
          props.atsUpdateSchedulingUserIntegrationUserInfoEnabled,
      }}
    >
      <JobPage
        activeTab={props.activeTab}
        atsSignableOfferEnabled={props.atsSignableOfferEnabled}
        atsHrisExportV2Enabled={props.atsHrisExportV2Enabled}
        jobBoardEnabled={props.jobBoardEnabled}
        emailAccountIntegration={props.emailAccountIntegration}
        standardNpsCalculation={props.standardNpsCalculation}
        duplicateJobEnabled={props.duplicateJobEnabled}
        selfSchedulingLinkOptionsEnabled={
          props.selfSchedulingLinkOptionsEnabled
        }
        offerRequisitionFlowEnabled={props.offerRequisitionFlowEnabled}
      />
    </FeatureFlagContext.Provider>
  );
}

export function ApplicantTrackingJobsApp(props: PropTypes) {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={'jobs'}>
          <Route path={'new/*'} element={<CreateJobPageRoutes />} />
          <Route
            path={'setup/*'}
            element={
              <SetupJobPageRoutes
                hrisProvider={props.hrisProvider}
                jobRequisitionEnabled={props.jobRequisitionEnabled}
                jobRequisitionMandatory={props.jobRequisitionMandatory}
                updateJobRequisitionEnabled={true}
                organicPostSkillsEnabled={props.organicPostSkillsEnabled}
                atsIndeedIntegrationEnabled={props.atsIndeedIntegrationEnabled}
                atsUpdateSchedulingUserIntegrationUserInfoEnabled={
                  props.atsUpdateSchedulingUserIntegrationUserInfoEnabled
                }
              />
            }
          />
          <Route
            path={':id/edit/*'}
            element={
              <EditJobPage
                hrisProvider={props.hrisProvider}
                jobRequisitionMandatory={props.jobRequisitionMandatory}
                organicPostSkillsEnabled={props.organicPostSkillsEnabled}
                atsIndeedIntegrationEnabled={props.atsIndeedIntegrationEnabled}
                atsUpdateSchedulingUserIntegrationUserInfoEnabled={
                  props.atsUpdateSchedulingUserIntegrationUserInfoEnabled
                }
              />
            }
          />
          <Route
            path={':id/overview'}
            element={<JobPageRouteTab {...props} activeTab='Overview' />}
          />
          <Route
            path={':id/pipeline'}
            element={<JobPageRouteTab {...props} activeTab='Pipeline' />}
          />
          <Route
            path={':id/paid_job_boards'}
            element={<JobPageRouteTab {...props} activeTab='Paid Job Boards' />}
          />
          <Route
            path={':id'}
            element={<JobPageRouteTab {...props} activeTab='Pipeline' />}
          />
          <Route
            path='*'
            element={
              <EmptyState
                title={'Page not found!'}
                text={
                  'For more information contact our support team at support@screenloop.com'
                }
                cardless={true}
              />
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
